export const CONTACT_ADMIN = 'Contact your admin for assistance.';
export const INVALID_CREDENTIALS_ENTERED = 'Invalid credentials entered.';
